module.exports = __webpack_public_path__ + "img/Default User.d78a57c2.svg";